import { FrontendConfigurationSchema } from './config.schema';

export class FrontendConfiguration implements FrontendConfigurationSchema {
    public displayWarningsToJavascriptConsole: boolean = true;
    public version: string = '1.2.8';
    public hostname: string = 'test.patientpace.medpace.com';
    public backendUrl: string = `https://${this.hostname}`;
    public userIdleSeconds: number = 15 * 60; // 15 mins
    public userTimeoutSeconds: number = 5 * 60; // 5 mins
    public appInsightsConnectionString: string = 'InstrumentationKey=c2bb84f0-6935-404d-8387-39147bd29961;IngestionEndpoint=https://eastus2-0.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus2.livediagnostics.monitor.azure.com/;ApplicationId=163210df-21b9-43fb-96ea-2e9e11fb8046';
    public production: boolean = false;
}
